import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getPolicyDocumentsEnglishMedical } from "../../../Redux/IndividualMedicalRedux";
import { updateLeadsMedical } from "../../../Redux/LogsRedux/Medical/MedicalLeadsRedux";
import CustomModal from "../../Common/CustomModal/CustomModal";

function AffordableHealthPlan({ planDetails }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { t,i18n} = useTranslation();
  // const { planDetails } = location.state || {};

  const data = {
    selectedPlanAmount: planDetails?.affordablePlans?.premium,
    annualLimit: "1 Year Coverage",
    opDetectable: "Nil",
    coPay: "Nil",
    inPatientCoverage: 4000,
    outPatientCoverage: 500,
    link: "table-of-benefits-affordable",
    filename: "Table Of Benefits",
  };
  const [isSelected, setIsSelected] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [fileName, setFileName] = useState();
  const [isSummaryOpen, setIsSummaryOpen] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [showError,setShowError] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);

  const handleSelect = () => {
    setIsSelected(true);
  };

  const handleNext = () => {
    if (!isSelected) return;
    setShowConfirm(true);
  };

  const handleConfirm = () => {
    if (!isSelected) {
      setShowError(true);
      return;
    }
    const payload = {
      transId: localStorage.getItem("MEDICAL_LEAD_ID"),
      selectedPlan: data,
    };
    dispatch(updateLeadsMedical(payload)).then((response) => {
      if (response.success) {
        const updatedData = {
          ...planDetails,
          selectedLimit: data,
        };
        setShowConfirm(false);
        navigate("/personal-information", {
          state: { planDetails: updatedData },
        });
      }
    });
  };

  const handlePreview = async (policy, fileName) => {
    setFileName(policy.filename);

    try {
      const res = await dispatch(getPolicyDocumentsEnglishMedical(policy.link));

      if (!res || !res.data) {
        throw new Error("No document data received");
      }

      const pdfUrl = res.data;

      // Keep original URL for download
      setSelectedPdf(pdfUrl);

      // ❌ REMOVE THIS (causes CORS error)
      // const response = await fetch(pdfUrl);

      // ✅ USE PROXY INSTEAD
      const proxyUrl = `${process.env.REACT_APP_API_URL}/proxy-pdf?url=${encodeURIComponent(pdfUrl)}`;

      setPreviewUrl(proxyUrl);

      setIsSummaryOpen(true);

    } catch (err) {
      console.error("PDF preview failed:", err);
    }
  };

  return (
    <>
      <CustomModal
        isOpen={isSummaryOpen}
        onClose={() => {
          setIsSummaryOpen(false);
          setSelectedPdf(null);
          if (previewUrl) {
            URL.revokeObjectURL(previewUrl);
            setPreviewUrl(null);
          }
        }}
        title={fileName}
        download={true}
        pdfUrl={selectedPdf}
      >
        <div
          className="modal-body"
          style={{ overflow: "hidden", padding: 0, height: "70vh" }}
        >
          {previewUrl && (
            <iframe
              title="View Document"
              src={`${previewUrl}#page=1&toolbar=0`}
              width="100%"
              height="95%"
              style={{ border: "none" }}
            />
          )}
        </div>
      </CustomModal>
      <div className="row">
        <div className="col-md-12 p-3">
          {/* <h3 className="title pt-2 mb-2">{t(planDetails?.coverPlan)}</h3> */}
          <h5 className="title subHeader p-0 fw-bold mb-2">
            {t("choose your plan")}
          </h5>
        </div>
      </div>
      <div className="row plan-grid justify-content-center">
        <div className="col-lg-3 col-md-4">
          <div
            className={`plan-card-ind mb-4 p-4 ${isSelected ? "active-plan" : ""}`}
            role="button"
            tabIndex={0}
            onClick={handleSelect}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                handleSelect();
              }
            }}
          >
            <div className="plan-info p-1 mt-4">
              <p className="plan-label">{t("Premium")}</p>
              <p className="plan-price">
                <span className="price-amount">
                  {(() => {
                    const premium = Number(
                      planDetails?.affordablePlans?.premium,
                    );

                    return Number.isInteger(premium)
                      ? `${premium}.000`
                      : premium;
                  })()}
                </span>
                <span className="price-currency"> OMR</span>
              </p>
              <hr />
              <p className="plan-name u">{t(data?.annualLimit)}</p>
              <p className="plan-benefits mt-2">
                {t("In Patient Coverage")} {data?.inPatientCoverage} OMR
              </p>
              <p className="plan-benefits mt-2">
                {t("Out Patient Coverage")} {data?.outPatientCoverage} OMR
              </p>
              <p className="plan-benefits mt-2">
                {t("OP deductible")} {data?.opDetectable}
              </p>
              <p className="plan-benefits m-2">
                {t("Pm Co Pay")} {data?.coPay}
              </p>
              <hr />
              <div className={`${i18n.language === "ar" ? "text-end" : "text-start"}`}>
                <p className="plan-download mb-2">
                  <i className="bi bi-file-earmark-text me-1"></i>
                  <a
                    href={data?.link}
                    className="download-link"
                    onClick={(e) => {
                      e.preventDefault();
                      handlePreview(data);
                    }}
                  >
                    {t("download table of benefits")}
                  </a>
                </p>
              </div>
            </div>
            <div className="planSelect">
              <a
                className={`round ${isSelected ? "active" : ""}`}
                onClick={handleSelect}
              >
                <i
                  className={`bi bi-check-lg plan-select-icon ${isSelected ? "bi-check-lg" : "bi-plus"}`}
                ></i>
              </a>
            </div>
          </div>
          {!isSelected && showError && (
            <label className="text-danger d-flex justify-content-center m-0 p-0">
              Please select the plan
            </label>
          )}
        </div>
      </div>
      <div className="row justify-content-center pb-4">
        <div className="col-lg-4 col-md-4"></div>
        <div className="col-lg-4 col-md-4"></div>
         <div className={`col-lg-4 col-md-4 ${i18n.language === "ar" ? "text-start" : "text-end"} mb-2`}>
          <button
            type="button"
            onClick={handleConfirm}
            className="btn btn-primary"
          >
            {t("Next")}
          </button>
        </div>
      </div>
      {showConfirm && (
        <>
          <div
            className="modal fade show"
            style={{ display: "block" }}
            role="dialog"
            aria-modal="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header border-0">
                  <h5 className="modal-title">{t("Plan Details")}</h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={() => setShowConfirm(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <span className="fw-semibold">{t("Plan Details")}</span>
                    <span className="fw-bold">
                      {planDetails?.affordablePlans?.premium} OMR
                    </span>
                  </div>
                  <hr />
                  <p className="plan-benefits mb-2">
                    {t("In Patient Coverage")} {data?.inPatientCoverage} OMR
                  </p>
                  <p className="plan-benefits mb-2">
                    {t("Out Patient Coverage")} {data?.outPatientCoverage} OMR
                  </p>
                  <p className="plan-benefits mb-2">{t(data?.annualLimit)}</p>
                </div>
                <div className="modal-footer border-0">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleConfirm}
                  >
                    {t("Confirm Plan")}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </>
  );
}

export default AffordableHealthPlan;
